import ESSDocumentList from './ESSComponents/DocumentList/index.js';
import I9DocumentList from './ESSComponents/I9DocumentList/index.js';
import I9VDocList from './ESSComponents/I9EverifyDocList/index.js';

const ESSMixin = {
    components:{
        "ob-ess-document" : ESSDocumentList,
        "ob-I9-doclist" : I9DocumentList,
        "ob-vdoc-list" : I9VDocList,
    }
}
export default ESSMixin


// WEBPACK FOOTER //
// ./src/components/ESSProfile/ESSMixin.js